import { useSelector } from 'react-redux';

import { Layout } from 'common/components/layout';
import { useLocalization } from 'redux/localization/utils/hooks';

import SuggestedProductsLoader from './SuggestedProductsLoader';

const ProductNotFound = () => {
  const settings = useSelector((state) => state.setting.data);
  const { t } = useLocalization();

  return (
    <>
      <Layout
        title={t('products.general.productNotFoundTitle')}
        description={t('products.general.productNotFoundTitle')}
      >
        <section className="c7-content c7-error-page">
          <h1 className="c7-h1">
            {t('products.general.productNotFoundTitle')}
          </h1>
          <p>
            {t('products.general.productNotFoundMessage')}{' '}
            <a href={settings.continueShopping}>
              {t('products.general.notFoundMessageLink')}
            </a>{' '}
            {t('products.general.productNotFoundMessage2')}
          </p>
          <div className="c7-error-page__recommendations">
            <h2 className="c7-h2">
              {t('products.general.productNotFoundSuggestedProductsTitle')}
            </h2>
            <SuggestedProductsLoader />
          </div>
        </section>
      </Layout>
    </>
  );
};

export default ProductNotFound;
